import { render } from "./FormClient.vue?vue&type=template&id=fa77ae08&scoped=true"
import script from "./FormClient.vue?vue&type=script&lang=js"
export * from "./FormClient.vue?vue&type=script&lang=js"

import "./FormClient.vue?vue&type=style&index=0&id=fa77ae08&scoped=true&lang=scss"

import exportComponent from "D:\\source\\Mobaxe.Docs.App\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa77ae08"]])

export default __exports__